import { render, staticRenderFns } from "./role_page.vue?vue&type=template&id=62a001a5&scoped=true"
import script from "./role_page.vue?vue&type=script&lang=js"
export * from "./role_page.vue?vue&type=script&lang=js"
import style0 from "./role_page.vue?vue&type=style&index=0&id=62a001a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a001a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a001a5')) {
      api.createRecord('62a001a5', component.options)
    } else {
      api.reload('62a001a5', component.options)
    }
    module.hot.accept("./role_page.vue?vue&type=template&id=62a001a5&scoped=true", function () {
      api.rerender('62a001a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/role_page.vue"
export default component.exports